exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".saved-filter{padding-right:10px;margin-top:-9px}input.user-filter-value,select.form-control{width:180px;display:inline;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0f35f5f2!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FilterValue.vue
// module id = 845
// module chunks = 2